module.exports = __webpack_public_path__ + "img/floor_f8_01.40454566.png";